<template>
  <v-list-item
		:two-line="!!item.potencia.nome"
		@click="onClickItemBusca"
	>
		<v-list-item-avatar>
			<v-img v-if="item.urlLogo" :src="item.urlLogo">
				<template v-slot:placeholder>
					<v-progress-circular indeterminate color="grey"></v-progress-circular>
				</template>
			</v-img>
      <v-icon v-else v-text="'mdi-bank'"/>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title>{{ item.nome }}</v-list-item-title>
			<v-list-item-subtitle>
				<slot name="subtitle">
      		{{ item.potencia.nome }}
				</slot>
			</v-list-item-subtitle>
    </v-list-item-content>
		<div v-if="typeof item.qtdIrmaos === 'number'">
			{{ item.qtdIrmaos }} IIr
		</div>
  </v-list-item>
</template>

<script setup lang="ts">
import { PropType } from 'vue'
import { Loja } from '../../common/types/Loja'
import { adicionarBuscaRecente } from '@/shareds/buscasRecentes'
import { ResultadoBusca } from '../../common/types/Busca'
import { useRouter } from '@/composables/router'

const props = defineProps({
	item: { type: Object as PropType<Loja>, required: true },
})

const router = useRouter()

function onClickItemBusca() {
	adicionarBuscaRecente(props.item as ResultadoBusca)
	router.push({
		name: 'detalhar-loja',
		params: { id: props.item._id },
	})
}
</script>
